<mat-card class="offer-ordered-overview-detail mt-2 offer-ordered-overview">
  <h3 class="offer-ordered-overview__title"
      *appApplyIfNotEmpty="translationService.getTranslation('offer_ordered_title')"
      [innerHTML]="translationService.getTranslation('offer_ordered_title')"></h3>
  <div class="offer-ordered-overview__description"
       [innerHTML]="translationService.getTranslation('offer_ordered_description')"></div>
  @if (!isUserLoggedIn) {
    <div class="offer-ordered-overview__no-user"
         [innerHTML]="translationService.getTranslation('offer_ordered_no_logged_in_user')"></div>
  }
  <div id="orderConfirmation" class="offer-ordered-overview__confirmation">
    @if (offer && offer.confirmationText) {
      <div id="orderConfirmationText"
           class="offer-ordered-overview__confirmation-text"
           [innerHTML]="offer?.confirmationText"></div>
    }
    @if (offer && offer.confirmationImage && offer.confirmationImage.type) {
      <img id="orderConfirmationImage" class="w-50 offer-ordered-overview__confirmation-image"
           [ngSrc]="offer.confirmationImage.src"
           [width]="imageService.width"
           [height]="imageService.height"
           [priority]="true"
           [alt]="offer.confirmationImage.altText" fitImage>
    }
  </div>
  @if (loading) {
    <div class="offer-ordered-overview__loading" style="text-align: center; margin:5px">
      <app-loading-spinner/>
    </div>
  } @else if (order) {
    <div class="row offer-ordered-overview__row">
      @if (order.productDescription && order.variantDescription) {
        <div class="col-6 offer-ordered-overview__product-label"
             [innerHTML]="translationService.getTranslation('order_object') + ' / ' + translationService.getTranslation('order_edition')"></div>
        <div class="col-6 offer-ordered-overview__product-value">{{ order.productDescription }}
          / {{ order.variantDescription }}
        </div>
      }
      @if (offer?.description) {
        <div class="col-6 mb-4 offer-ordered-overview__offer-label"
             [innerHTML]="translationService.getTranslation('order_product')"></div>
        <div class="col-6 mb-4 offer-ordered-overview__offer-value">{{ offer.description | stripHtml }}</div>
      }

      @if (selectedGifts.length > 0) {
        <div class="col-6 offer-ordered-overview__gift-label"
             [innerHTML]="translationService.getTranslation('order_bonus')"></div>
        <div class="col-6 offer-ordered-overview__gift-value">
          @for (gift of selectedGifts; track $index) {
            <div class="offer-ordered-overview__gift-item">{{ gift.articleDescription }}</div>
          }
        </div>
      }

      <ng-container>
        <div class="col-6 offer-ordered-overview__period-label"
             [innerHTML]="translationService.getTranslation('period')"></div>
        <div class="col-6 offer-ordered-overview__period-value">
          {{ order.validDate.validFrom | date: translationService.getTranslation('dateFormat') }}
          - {{ order.validDate.validUntil ? (order.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless') }}
        </div>
      </ng-container>
      @if (order.curDelivery && showDeliveryAddress()) {
        <div class="col-6 offer-ordered-overview__delivery-label"
             [innerHTML]="translationService.getTranslation('address_delivery')"></div>
        <div class="col-6 offer-ordered-overview__delivery-value">
          {{ order.curDelivery.person.addressCodeDescription }} {{ personTitle(order.curDelivery.person) }} {{ order.curDelivery.person.firstname }} {{ order.curDelivery.person.lastname }} {{ order.curDelivery.address.street }} {{ order.curDelivery.address.country === 'A' ? order.curDelivery.address.houseno + " " + order.curDelivery.address.stock + " " + order.curDelivery.address.stiege + " " + order.curDelivery.address.tuer : order.curDelivery.address.houseno }} {{ order.curDelivery.address.zipcode }} {{ order.curDelivery.address.city }}
        </div>
      }
      @if (order.curBilling) {
        <div class="col-6 offer-ordered-overview__billing-label"
             [innerHTML]="translationService.getTranslation('address_billing')"></div>
        <div class="col-6 offer-ordered-overview__billing-value">
          {{ order.curBilling.person.addressCodeDescription }} {{ personTitle(order.curBilling.person) }} {{ order.curBilling.person.firstname }} {{ order.curBilling.person.lastname }} {{ order.curBilling.address.street }} {{ order.curBilling.address.country === 'A' ? order.curBilling.address.houseno + " " + order.curBilling.address.stock + " " + order.curBilling.address.stiege + " " + order.curBilling.address.tuer : order.curBilling.address.houseno }} {{ order.curBilling.address.zipcode }} {{ order.curBilling.address.city }}
        </div>
      }

      @if (bonusRecipient) {
        <div class="col-6 offer-ordered-overview__bonus-address-label"
             [innerHTML]="bonusAddressTitle()"></div>
        <div class="col-6 offer-ordered-overview__bonus-address-value">
          {{ recipientAddressLine(bonusRecipient) }}
        </div>
      }
      @if (advertiserRecipient) {
        <div class="col-6 offer-ordered-overview__advertiser-address-label"
             [innerHTML]="translationService.getTranslation('address_advertiser')"></div>
        <div class="col-6 offer-ordered-overview__advertiser-address-value">
          {{ recipientAddressLine(advertiserRecipient) }}
        </div>
      }

      @if (order.curPayment) {
        <div class="col-6 offer-ordered-overview__payment-label"
             [innerHTML]="translationService.getTranslation('payment_type')"></div>
        <div class="col-6 offer-ordered-overview__payment-value">
          {{ paymentDescription() }} <br>
          @if (order.curPayment?.bank?.swiftIBAN) {
            <span class="offer-ordered-overview__payment-iban">
              {{ translationService.getTranslation('payment_iban') + ': ' + order.curPayment.bank?.swiftIBAN | bankAccount }}
            </span>
          }
        </div>
      }

      @if (price?.length > 0 || offer?.additionalPriceDescription?.length > 0) {
        <div class="col-6 offer-ordered-overview__price-label"
             [innerHTML]="translationService.getTranslation('price')"></div>
        @for (pricePart of price; track price) {
          @if (offer?.priceCalculationActivated) {
            <div class="col-6 offer-ordered-overview__price-value">
              {{ pricePart?.price | number : '1.2-2' }} {{ pricePart.currency }}
              @if (pricePart.porto) {
                <div class="offer-ordered-overview__price-delivery"
                     [innerHTML]="translationService.getTranslation('price_delivery') + ' ' + (pricePart?.porto | number : '1.2-2') + ' ' + pricePart.currency + ' ' + pricePart.portoDescription">
                </div>
              }
            </div>
          } @else {
            <div class="col-6 offer-ordered-overview__price-text">{{ pricePart?.priceText }}</div>
          }
          <div class="col-6 offer-ordered-overview__price-empty"></div>
        }
        <div class="col-6 offer-ordered-overview__additional-price"
             [innerHTML]="offer?.additionalPriceDescription"></div>
      }
      @if (order.commitmentDate) {
        <div class="col-6 offer-ordered-overview__commitment-label"
             [innerHTML]="translationService.getTranslation('commitmentDate')"></div>
        <div class="col-6 offer-ordered-overview__commitment-value">{{ order.commitmentDate | date: translationService.getTranslation('dateFormat') }}</div>
      }
    </div>
  }
  @if (timeUntilRedirectSeconds > 0 && redirectUrl?.length > 0) {
    <div class="mt-3 offer-ordered-overview__redirect">
      Sie werden in {{ timeUntilRedirectSeconds }} Sekunden weiter geleitet.
    </div>
  }
  <ng-container>
    <div class="mt-3 offer-ordered-overview__button-container">
      <button mat-raised-button color="primary"
              class="offer-ordered-overview__button"
              (click)="routeToOrderList()"
              [innerHTML]="translationService.getTranslation('button_go_to_subscription_overview')"></button>
    </div>
  </ng-container>
</mat-card>
